module.exports = __webpack_public_path__ + "static/img/qmts06-card-bg.bcccc977.png";